import { isTauri } from "./runtime";

/**
 * Soft host gate for the web build: allow Tauri, local dev, and our domains.
 * Easy to strip from the bundle — only meant to stop casual rehosts of `dist/`.
 */
export function isAllowedHost(): boolean {
  if (typeof window === "undefined") return true;
  if (isTauri()) return true;

  const host = window.location.hostname.toLowerCase();
  if (host === "localhost" || host === "127.0.0.1" || host === "[::1]") {
    return true;
  }

  return host === "zephyrwrite.com" || host.endsWith(".zephyrwrite.com");
}

/** Public browser demo (try.zephyrwrite.com). Not the signed-in cloud editor. */
export function isTryHost(): boolean {
  if (typeof window === "undefined") return false;
  return window.location.hostname.toLowerCase() === "try.zephyrwrite.com";
}
